import React, { useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://luxury-browes.impultienda.ar/checkout';
const UPSELL_CHECKOUT_URL = 'https://luxury-browes.impultienda.ar/checkout';
export function PricingSection() {
  const included = ['Acceso de por vida al programa', 'Acceso a todos los BONOS', '27 clases prácticas paso a paso', '4 Tomos organizados', 'Plantillas prácticas para aplicar', 'Garantía de 7 días'];
  const currentCheckout = CHECKOUT_URL;
  return <section id="compra" className="bg-gradient-to-b from-gray-900 to-black text-white py-8 md:py-12 px-4 bg-[#090202] pt-[60px] pb-[60px] mt-[-35px] mb-[-35px]" data-id="element-260">
      <div className="max-w-3xl mx-auto" data-id="element-261">
        {/* Header */}
        <div className="rounded-t-2xl px-6 py-8 text-center mt-[-20px] mb-[-20px] bg-[#BE19BE]" data-id="element-262">
          <h2 className="md:text-3xl font-black uppercase mb-3 text-[35px]" data-id="element-263">
            Accede ahora
          </h2>
          <p className="text-base md:text-lg text-green-100 max-w-xl mx-auto" data-id="element-264">
            Y recupera tu inversión con 1 o 2 clientas.
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-b-3xl p-6 md:p-10 shadow-2xl border-2 border-t-0 border-slate-600 bg-[#444040]" data-id="element-265">
          {/* Product Title & Includes */}
          <div className="text-center mb-6" data-id="element-266">
            <h3 className="text-3xl md:text-4xl font-black text-slate-200 mb-2 tracking-wide" data-id="element-267">
              ✨ Luxury Brow Extensions✨
            </h3>
            <p className="text-xl text-white mb-6 font-[500]" data-id="element-268">Resumen</p>

            <div className="text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-269">
              {included.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-270">
                  <span className="w-3 h-3 rounded-full flex-shrink-0 bg-[#BE19BE]" data-id="element-271"></span>
                  <span className="text-base md:text-lg text-slate-200 font-medium" data-id="element-272">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Plan Options */}
          <div className="space-y-4 mb-8" data-id="element-273">
            {/* Single Plan - $49.990 */}
            <div className="relative rounded-2xl p-5 md:p-6 border-2 border-[#BE19BE] shadow-[0_0_20px_rgba(190,25,190,0.2)] bg-[#1C1C23]" data-id="element-274">
              {/* Badge */}
              <div className="absolute -top-3 left-4" data-id="element-275">
                <span className="inline-flex items-center gap-1.5 bg-[#BE19BE] text-white text-xs font-black uppercase tracking-wider px-4 py-1.5 rounded-full shadow-lg" data-id="element-276">
                  Oferta Especial ⭐⭐⭐⭐⭐
                </span>
              </div>

              <div className="flex items-center justify-between mt-2" data-id="element-277">
                <div data-id="element-278">
                  <p className="text-lg font-bold text-white mb-1" data-id="element-279">
                    Programa Brow Extensions Completo + 5 BONUS 🎁
                  </p>
                  <p className="text-sm text-red-400 font-bold line-through mb-1" data-id="element-280">
                    Antes $89 USD
                  </p>
                  <p className="text-3xl md:text-4xl font-black text-[#BE19BE]" data-id="element-281">
                    601,08 Pesos Mexicanos / 34.90 usd
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-282">
            <motion.div animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-283">
              <CTAButton text="ACCEDER AL PROGRAMA →" href={currentCheckout} size="large" className="!bg-[#BE19BE] hover:!bg-[#A015A0] !text-white font-black text-lg md:text-xl w-full shadow-[0_0_30px_rgba(190,25,190,0.4)] hover:shadow-[0_0_40px_rgba(190,25,190,0.6)]" data-id="element-284" />
            </motion.div>

            <div className="mt-8 flex flex-col items-center gap-3" data-id="element-285">
              <img src="https://cdn.magicpatterns.com/uploads/wLvEvhsSpnkTUz3a5aCgpE/medios-de-pago-paypal-min.png" alt="Paypal International" loading="lazy" className="h-20 object-contain bg-white rounded-lg px-4 py-2" data-id="element-286" />
              <p className="text-sm text-slate-400 font-semibold" data-id="element-287">
                🔒 Compra verificada y protegida por Paypal International
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-900 bg-opacity-50 border-2 border-blue-400 rounded-2xl p-8 text-center pt-[20px] pb-[20px] mt-[25px] mb-[25px]" data-id="element-288">
          <img src="https://cdn.magicpatterns.com/uploads/uJUkiYW4VEvaYTb76LJCEm/Historias_Destacadas_(1).png" alt="Garantía 7 días - 100% de satisfacción" loading="lazy" className="w-32 h-32 md:w-40 md:h-40 object-contain mx-auto mb-4" data-id="element-289" />
          <h4 className="text-2xl font-bold mb-4" data-id="element-290">
            ✓ Garantía de 7 días sin vueltas
          </h4>
          <p className="text-lg text-gray-300" data-id="element-291">
            Queremos que entres con tranquilidad. Si accedes al programa y
            sientes que no era para ti, puedes pedir la devolución. Sin
            preguntas ni complicaciones.
          </p>
        </div>

        {/* ¿Cuánto cuesta NO tenerlo? */}
        <div className="mt-10 rounded-2xl border-2 border-purple-500/50 overflow-hidden bg-[#0A0D16]" data-id="element-292">
          <div className="text-center py-8 px-4" data-id="element-293">
            <h3 className="text-2xl md:text-4xl font-black text-white uppercase" data-id="element-294">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h3>
          </div>

          {/* Table */}
          <div className="mx-4 mb-6 rounded-xl overflow-hidden border border-purple-500/30" data-id="element-295">
            {/* Header */}
            <div className="grid grid-cols-2" data-id="element-296">
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/30" data-id="element-297">
                <p className="text-white font-bold text-sm md:text-lg text-center" data-id="element-298">
                  Sin Luxury Brow Extensions
                </p>
              </div>
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5" data-id="element-299">
                <p className="text-[#FC9DFF] font-bold text-sm md:text-lg text-center" data-id="element-300">
                  Costo real
                </p>
              </div>
            </div>

            {/* Rows */}
            {[{
            sin: 'Horas buscando técnica gratis en YouTube',
            costo: 'Meses de frustración sin resultados reales'
          }, {
            sin: 'Comprar materiales sin saber usarlos',
            costo: 'Dinero tirado en insumos que no sirven'
          }, {
            sin: 'No saber cobrar el servicio correctamente',
            costo: 'Seguir regalando tu trabajo y tiempo'
          }, {
            sin: 'Técnicas que dañan la ceja natural',
            costo: 'Clientas que no vuelven y mala reputación'
          }, {
            sin: 'Sin un paso a paso profesional',
            costo: 'Te trabas y abandonas por falta de guía'
          }, {
            sin: 'Miedo a ofrecer servicios nuevos',
            costo: 'Seguís ofreciendo lo mismo que el resto'
          }, {
            sin: 'Esperar a que la tendencia pase',
            costo: 'Tu competencia lo hace primero y pierdes mercado'
          }].map((row, index) => <div key={index} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-[#12121f]' : 'bg-[#0e0e1a]'}`} data-id="element-301">
                <div className="px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/20" data-id="element-302">
                  <p className="text-gray-300 text-xs md:text-base" data-id="element-303">
                    {row.sin}
                  </p>
                </div>
                <div className="px-4 py-4 md:px-6 md:py-5" data-id="element-304">
                  <p className="text-white font-bold text-xs md:text-base" data-id="element-305">
                    {row.costo}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mental Triggers */}
        <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-306">
          <div className="rounded-xl p-6 border border-gray-800 flex items-start gap-4 bg-[#0A0D16]" data-id="element-307">
            <div className="bg-green-500/20 p-3 rounded-lg text-green-500 shrink-0" data-id="element-308">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-309">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-310" />
              </svg>
            </div>
            <div data-id="element-311">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-312">
                Retorno Inmediato
              </h3>
              <p className="text-gray-400" data-id="element-313">
                Recuperas la inversión con tu primera clienta. El riesgo es 0.
              </p>
            </div>
          </div>

          <div className="bg-gray-900/50 rounded-xl p-6 border border-gray-800 flex items-start gap-4" data-id="element-314">
            <div className="bg-yellow-500/20 p-3 rounded-lg text-yellow-500 shrink-0" data-id="element-315">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-316">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-317" />
              </svg>
            </div>
            <div data-id="element-318">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-319">
                Acción Rápida
              </h3>
              <p className="text-gray-400" data-id="element-320">
                Los BONUS y el valor especial están por terminar!!
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-321">
          <p className="text-gray-400 mt-4 text-sm font-medium" data-id="element-322">
            🔒 Pago 100% seguro y garantizado
          </p>
        </div>
      </div>
    </section>;
}